export function getDefaultBackgrounds() {
  const baseURL = window.env.REACT_APP_DEFAULT_BACKGROUND_URL ?? '/default-backgrounds';
  return [...new Array(6)].map((_, i) => `${baseURL}/bg-${i + 1}.jpg`);
}
